import React from "react";
import moment from 'moment';
import {component_tool, utils_tool} from "@/tool";
import CoursewareSync from "./coursewareSync/coursewareSync";
import {WizTableForm} from '@/containers/common'

const coursewareConfig = WizTableForm.Config.courseware(this, {apiParams: {}})
let {WizModal} = component_tool;
let {$$, checkStrLength} = utils_tool;
//配置接口项
let componentName = 'coursewareManagement';
let ref_;
const formatterDate = (val) => {
  return val ? moment(val).format('YYYY-MM-DD HH:mm:ss') : '';
};
const columns = [
  {
    name: "id",
    formItem: {
      type: "hidden"
    }
  },
  {
    title: "名称",
    name: "nameSearch",
    searchItem: {}
  },
/*  {
    title: "课件",
    name: "coursewareIdList",
    searchItem: {
      diy: WizTableForm,
      selectType: 'radio',
      ...coursewareConfig,
    }
  },*/
  {
    title: "名称",
    name: "name",
    tableItem: {
      width: 200,
    }
  },
  {
    title: "课件编号",
    name: "codeSearch",
    searchItem: {}
  },
  {
    title: "课件编号",
    name: "code",
    tableItem: {
      width: 200,
    }
  },
  {
    title: "平台",
    name: "channel",
    dict: [
      {code: 1, codeName: "scorm平台"},
    ],
    tableItem: {
      width: 100,
    },
    searchItem: {
      type: "select"
    }
  },
  {
    title: '最新更新时间',
    name: 'updateTime',
    dataIndex: "updateTime",
    tableItem: {
      render: text => {
        return formatterDate(text)
      }
    },
  },
];

const templateConfig = {
  mainProps: {},
  content: {
    name: "WizTableList",
    params: {
      columns,
      searchBarProps: {
        buttonSort: ['coursewareSynchronize'],
        buttons: [
          {
            key: 'coursewareSynchronize',
            custom: true,
            params: {icon: 'reload', children: '课件同步', type: 'primary'},
            customOnClick: {
              key: "modal",
              params: {
                modalKey: "coursewareSynchronize",
                modalParams: {
                  title: "第三方课件同步",
                  diy: (e) => {
                    const formProps = {
                      ref: 'form',
                      record: {},
                      preview: false,
                      footer: false,
                      formItemLayout: {
                        labelCol: {span: 4},
                        wrapperCol: {span: 17}
                      },
                    };
                    return (
                      <CoursewareSync {...formProps}
                                      key={'sync-courseware'}
                                      {...e}
                                      ref={r => {
                                        ref_ = r && r.getWrappedInstance();
                                      }}
                      />
                    )
                  },
                  onCancel: () => {
                    ref_._reset()
                  },
                  footer: null,
                  width: 700
                }
              }
            },
          },
        ]
      },
      modalFormProps: {
        key: "modal123",
        params: {
          modalParams: {
            title: "Modal",
            children: "Bla bla123 .."
          }
        }
      },
      dataTableProps: {
        rowKey: "id",
        selectType: "checkbox",
        isScroll: true,
        bordered: false,
        paging: false,
        loading: false,
      },
      rowOperateSort: ['look', 'updateCourseware'],
      rowOperateView: [
        {
          key: "updateCourseware",
          custom: true,
          params: {children: "更新课件"},
          customOnClick: {
            key: "action",
            params: {
              apiKey: "updateCourseware",
              apiParams: {}
            },
            formatParams: (rows, record, filters, callback) => {
              let name = record['name'];
              const content = `您确定要更新【` + name + `】课件吗？`;
              WizModal.confirm({
                title: '注意', content,
                onOk: () => {
                  callback && callback({
                    id: record['id'],
                    code: record['code'],
                    channel: record['channel'],
                  })
                },
                onCancel() {
                }
              });
              return null
            }
          }
        },
        {
          key: "look",
          custom: true,
          params: {children: "查看"},
          customOnClick: {
            key: "jumpPage",
            params: {
              key: "push",
              pathname: "/courseware/coursewareShow"
            }
          }
        },
      ],
      commonOperate: {
        add: true,
        delete: false,
        update: true,
        look: true

      }
    }
  }
};

const apis = {
  list: {
    path: `${componentName}/listByPage`,
    payload: {
      key: `${componentName}@listByPage`,
      apiParams: {pageNum: 1, pageSize: 10}
    }
  },
  coursewareSynchronize: {
    path: `${componentName}/coursewareSynchronize`,
    payload: {
      key: `${componentName}@coursewareSynchronize`,
      apiParams: {}
    }
  },
  updateCourseware: {
    path: `${componentName}/updateCourseware`,
    payload: {
      key: `${componentName}@updateCourseware`,
      apiParams: {}
    }
  }
}


let reduxTemplateConfig = (args) => {
  return {
    apis,
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export {reduxTemplateConfig, templateConfig};
